import { render, staticRenderFns } from "./TrelloCard.vue?vue&type=template&id=9f4b9a68&scoped=true&"
import script from "./TrelloCard.vue?vue&type=script&lang=js&"
export * from "./TrelloCard.vue?vue&type=script&lang=js&"
import style0 from "./TrelloCard.vue?vue&type=style&index=0&id=9f4b9a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4b9a68",
  null
  
)

export default component.exports